import React, { createContext, useState } from 'react';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const [cart, setCart] = useState([]);

    const addToCart = (item) => {
        setCart(prevCart => {
            const existingItemIndex = prevCart.findIndex(
                cartItem => cartItem.productId === item.productId && cartItem.variant.id === item.variant.id
            );

            if (existingItemIndex !== -1) {
                // Si la variante es "Default Title", se trata como un ítem separado
                if (item.variant.title === "Default Title") {
                    return [...prevCart, item];
                }

                // De lo contrario, se agrega sin acumular cantidades
                return [...prevCart, item];
            } else {
                return [...prevCart, item]; // Agregar como nuevo ítem siempre
            }
        });
    };

    const removeFromCart = (productId, variantId) => {
        setCart(prevCart => {
            const indexToRemove = prevCart.findIndex(
                item => item.productId === productId && item.variant.id === variantId
            );
    
            if (indexToRemove !== -1) {
                const updatedCart = [...prevCart];
                updatedCart.splice(indexToRemove, 1); // Elimina solo el primer elemento encontrado
                return updatedCart;
            }
    
            return prevCart;
        });
    };
    

    const updateProductInCart = (productId, variantId, updatedItem) => {
        setCart(cart.map(item => (item.productId === productId && item.variant.id === variantId) ? updatedItem : item));
    };

    return (
        <CartContext.Provider value={{ cart, addToCart, removeFromCart, updateProductInCart }}>
            {children}
        </CartContext.Provider>
    );
};
